import BaseRepository from './base.repository';

class FilesRepository extends BaseRepository {
  constructor() {
    super('/files');
  }

  upload(formData) {
    return this.client.post('', formData);
  }

  uploadToken(request) {
    return this.client.post('/upload-token', request);
  }

  saveFileRecord(request) {
    return this.client.post('/records', request);
  }
}

export default new FilesRepository();
